const trains = {
  train: "Xe lửa", // translated 
  trains: "Tàu hỏa", // translated 
  fairConditions: "Điều kiện công bằng", // translated 
  to: "ĐẾN", // translated 
  earlier: "Trước đó", // translated 
  later: "Sau đó", // translated 
  adults: "Người lớn", // translated 
  child: "Đứa trẻ", // translated 
  senior: "Người lớn tuổi", // translated 
  seniors: "Người cao tuổi", // translated 
  price: "Giá", // translated 
  for: "vì", // translated 
  total: "Tổng cộng", // translated 
  selected: "Đã chọn", // translated 
  prebook: "Đặt trước", // translated 
  book: "Sách", // translated 
  payment: "Sự chi trả", // translated 
  return: "Trở lại", // translated 
  passengers: "Hành khách", // translated 
  delivery: "Vận chuyển", // translated 
  summary: "Bản tóm tắt", // translated 
  checkout: "Thanh toán", // translated 
  trainToastCorrectFillForm: "Vui lòng điền đầy đủ và chính xác tất cả các trường thông tin.", // translated 
  fareConditions: "Điều kiện giá vé", // translated 
  travelInfo: "Thông tin du lịch", // translated 
  remarks: "Nhận xét của khách hàng", // translated 
  noServices: "Không có dịch vụ nào", // translated 
  timesAndSeats: "Thời gian và chỗ ngồi", // translated 
  mobileTicket: "Vé điện tử", // translated 
  stationTicket: "Đón khách tại ga", // translated 
  homeTicket: "In tại nhà", // translated 
  countryCode: "Mã quốc gia", // translated 
  chooseTicket: "Chọn phương thức giao vé", // translated 
  ticketError: "Vui lòng chọn vé cho tất cả các điểm đến.", // translated 
  ticketDelivery: "Vui lòng chọn phương thức giao vé.", // translated 
  passengerDetails: "Thông tin hành khách", // translated 
  waitWhileProcessingPayment:
    "Vui lòng chờ trong khi chúng tôi xử lý thanh toán của bạn, đừng làm mới hoặc đóng trang.", // translated 
  reductionCardId: "Thẻ giảm giá ID", // translated 
  countryOfResidence: "Quốc gia cư trú", // translated 
  countryOfBirth: "Quốc gia sinh", // translated 
  documentCountry: "Quốc gia tài liệu", // translated 
  documentNumber: "Số tài liệu", // translated 
  expirationDate: "Ngày hết hạn", // translated 
  documentType: "Loại tài liệu", // translated 
  travelerDocumentInfo: "Thông tin giấy tờ du lịch", // translated 
  youth: "Thiếu niên", // translated 
  youths: "Thanh niên", // translated 
  departTimeEarlyFirst: "Giờ khởi hành (sớm nhất trước)", // translated 
};


export default trains;
